export enum AlertType
{
    WARN='Warn',
    SUCCESS ='Success', 
    ERROR="Error",
    CONFORMATION='Confirmation',
    AUTHENTICATE='Authenticate'
}
export enum AlertButtonColor
{
    WARN = ""
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/alerttype.tsx